import { Grid, Typography, RadioGroup, FormControlLabel, Radio, Theme } from '@mui/material';
import KenSelect from '../../../../../../GlobalComponents/KenSelect';
import { makeStyles } from '@mui/styles';
import { DROP_DOWN, QuizConfig } from '../Helper/AssessmentHelper';

interface IQuestion {
    assessmentData: QuizConfig;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        backgroundColor: '#F8FAFC',
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
    },
    label: {
        fontWeight: 500,
        textAlign: 'left',
    },
    label1: {
        fontWeight: 500,
        textAlign: 'left',
        height: "3rem"
    },
}));

const QuestionBehaviour: React.FC<IQuestion> = ({ assessmentData, handleChange }: IQuestion) => {
    const classes = useStyles();

    return (
        <Grid container spacing={2} className={classes.container}>
            <Grid item xs={12} md={3}>
                <Typography className={classes.label1}>Shuffle within questions</Typography>
                <RadioGroup
                    row
                    defaultValue="1"

                >
                    <FormControlLabel value="1" control={<Radio />} label="Yes" />
                    <FormControlLabel value="0" control={<Radio />} label="No" />
                </RadioGroup>
            </Grid>
            <Grid item xs={12} md={6}>
                <Typography className={classes.label1}>
                    Shuffle choices within answer (Only applicable to Multichoice, Match the following, drag & drop etc.)
                </Typography>
                <RadioGroup row
                    name="shuffleanswers"
                    value={assessmentData.shuffleanswers}
                    onChange={handleChange}
                >
                    <FormControlLabel value="1" control={<Radio />} label="Yes" />
                    <FormControlLabel value="0" control={<Radio />} label="No" />
                </RadioGroup>
            </Grid>

            <Grid item xs={12} md={4}>
                <Typography className={classes.label}>How questions behave</Typography>
                <KenSelect
                    fullWidth
                    name="preferredbehaviour"
                    value={assessmentData.preferredbehaviour}
                    onChange={handleChange}
                    options={DROP_DOWN.QuestionBehaviour}
                    sx={{ height: '3rem' }}
                />
            </Grid>
            {(["immediatefeedback","immediatecbm","interactive"].includes(assessmentData.preferredbehaviour))&&
                <Grid item xs={12} md={3}>
                    <Typography className={classes.label1}>Allow redo within an attempt</Typography>
                    <RadioGroup row
                     name="canredoquestions"
                     value={assessmentData.canredoquestions}
                     onChange={handleChange}
                    >
                        <FormControlLabel value="1" control={<Radio />} label="Yes" />
                        <FormControlLabel value="0" control={<Radio />} label="No" />
                    </RadioGroup>
                </Grid>
            }
            <Grid item xs={12} md={3}>
                <Typography className={classes.label1}>Each attempt builds on the last</Typography>
                <RadioGroup row
                 name="attemptonlast"
                 value={assessmentData.attemptonlast}
                 onChange={handleChange}
                >
                    <FormControlLabel value="1" control={<Radio />} label="Yes" />
                    <FormControlLabel value="0" control={<Radio />} label="No" />
                </RadioGroup>
            </Grid>
        </Grid>
    );
}

export default QuestionBehaviour